import {
  SessionStorage,
  decodeJwt,
  isBrowserStorageAvailable,
} from '@iheartjane/utils';
import { add } from 'date-fns/add';
import { fromUnixTime } from 'date-fns/fromUnixTime';
import { isBefore } from 'date-fns/isBefore';

import { AuthStorage } from './authStorage';

function storeJwt(token: string, headless: boolean) {
  if (headless && isBrowserStorageAvailable()) {
    SessionStorage.set('jwt', token);
    AuthStorage.remove('jwt');
  } else {
    AuthStorage.set('jwt', token);
  }
}

export function setJwt(jwt: string, headless = false) {
  if (jwt) {
    storeJwt(jwt, headless);
  }
}

export function getJwt() {
  const jwt = AuthStorage.get<string>('jwt');

  if (!jwt && isBrowserStorageAvailable()) {
    return SessionStorage.get('jwt');
  }

  return jwt;
}

export function removeJwt() {
  AuthStorage.remove('jwt');

  if (isBrowserStorageAvailable()) {
    SessionStorage.remove('jwt');
  }
}

export const parseToken = (token: string) =>
  token.includes('Bearer') ? token.split('Bearer ')[1] : token;

export const tokenIsExpired = (token: string, msFromNow: number) => {
  const { exp } = decodeJwt<{ exp: number }>(parseToken(token));
  const expiry = fromUnixTime(exp);
  const roughlyNow = add(new Date(), { seconds: msFromNow / 1000 });
  return isBefore(expiry, roughlyNow);
};
